export const MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE = 'mortgage_rate_hike_banner_closed';
